function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uploadVideo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "uploadVideo_svg__a",
  transform: "translate(87 113)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "uploadVideo_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "uploadVideo_svg__c",
  d: "M12.911 4H3.122A3.272 3.272 0 000 7.313v8.507a3.272 3.272 0 003.122 3.313h9.789a3.272 3.272 0 003.122-3.313V7.313A3.214 3.214 0 0012.911 4zM21.549 4.763l-3.983 3.02a1.053 1.053 0 00-.409.711v5.951a.778.778 0 00.409.711l3.983 3.109A1.507 1.507 0 0024 17.288V5.74a1.468 1.468 0 00-2.451-.977z"
}));

function SvgUploadVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgUploadVideo;